import React, { useState } from "react"
import { useHistory } from "react-router"
import { searchThuocsiProduct } from '../../../api'
import { Toast } from "../../../service/alert"
import { formatPrice, useAsync } from "../../../utils"
import Search, { useSearch } from "../../shared/Search"

const SearchThuocsiProduct = React.memo(() => {
    const history = useHistory()

    const search = useSearch()

    const searchProductAsync = useAsync(searchThuocsiProduct)

    const [state, setState] = useState<{
        offset: number,
        limit: number,
        listProduct: Array<any>,
        outOfData: boolean,
    }>({
        offset: 0,
        limit: 10,
        listProduct: [],
        outOfData: false,
    })

    const resetState = () => {
        setState({
            offset: 0,
            limit: 10,
            listProduct: [],
            outOfData: false,
        })
    }

    const handleSeach = (value: string) => {
        if (value === '') {
            resetState()
            return
        }

        const params = {
            offset: state.offset,
            limit: state.limit,
            where: {
                mProductName: {
                    like: `%${value}%`
                }
            }
        }
        searchProductAsync.execute(params).then(res => {
            setState(prev => ({
                ...prev,
                offset: 0,
                listProduct: res,
                outOfData: res.length === 0
            }))
        })
    }

    const onScrollHitBottom = () => {
        if (state.outOfData) return
        const params = {
            offset: state.offset + 10,
            limit: state.limit,
            where: {
                mProductName: {
                    like: `%${search.getValue()}%`
                }
            }
        }

        searchProductAsync.execute(params).then(res => {
            setState(prev => ({
                ...prev,
                offset: prev.offset + 10,
                listProduct: [...prev.listProduct, ...res],
                outOfData: res.length < 10
            }))
        })
    }

    return <div className='w-100'>
        <div id="main">
            <div className="container" >
                <Search
                    register={search}
                    placeholder='Tên sản phẩm'
                    onClear={resetState}
                    debounceTime={300}
                    onSearch={handleSeach}
                    onScrollHitBottom={onScrollHitBottom}
                    data={state.listProduct}
                    loading={searchProductAsync.status === "loading"}
                    dropdownData={(listProduct: Array<ThuocsiProductModel>, onSelect: () => void) => {
                        return listProduct.map((product: ThuocsiProductModel, index) => {

                            const firstImageUrl = JSON.parse(product.mImages)[0];

                            let retailPrice = product.mRetailPrice;
                            let originalPrice = undefined;
                            if (product.mDealStatus && product.mDealPrice) {
                                retailPrice = product.mDealPrice;
                                originalPrice = product.mRetailPrice;
                            }


                            return <li className="list-group-item">
                                <div className="media align-items-lg-center flex-column flex-lg-row p-3">
                                    <div className="media-body order-2 order-lg-1">
                                        <p className="mt-0 font-weight-bold mb-0">{product.mProductName}</p>
                                        <p className="mt-0 font-italic mb-0">Đóng gói: ({product.mVolumn})</p>
                                        <p className="mt-0 font-italic mb-2">
                                            Tình trạng: 
                                        {
                                            product.mStockStatus === 'OUT_OF_STOCK' ? <span className="text-danger"> Hết hàng</span> : <span className="text-success"> Còn hàng</span>
                                        }
                                        </p>
                                        <div className="mb-1"
                                            onClick={async () => {
                                                    await navigator.clipboard.writeText(product.mProductCode)
                                                    Toast.fire({
                                                        icon: 'success',
                                                        title: `Đã sao chép Mã sản phẩm`,
                                                        timer: 1000
                                                    })
                                            }}
                                        >
                                            <span>Mã SP: </span><span className="font-italic text-muted">{product.mProductCode}</span>
                                            <img className="ml-1 cursor-pointer" src="https://cdn-icons-png.flaticon.com/512/1621/1621635.png" width={16} />
                                        </div>
                                        <div className="mb-1"
                                            onClick={async () => {
                                                    await navigator.clipboard.writeText(product.mSkuCode)
                                                    Toast.fire({
                                                        icon: 'success',
                                                        title: `Đã sao chép Mã SKU`,
                                                        timer: 1000
                                                    })
                                            }}
                                        >
                                            <span>Mã SKU: </span><span className="font-italic text-muted">{product.mSkuCode}</span>
                                            <img className="ml-1 cursor-pointer" src="https://cdn-icons-png.flaticon.com/512/1621/1621635.png" width={16} data-toggle="tooltip" data-placement="left" title="Tooltip on left"/>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-start">
                                            <span>Giá bán: </span><span className="font-italic font-weight-bold text-success ml-1"> {formatPrice(retailPrice)} đ</span>
                                            {
                                                originalPrice && <span className="ml-1"> ← Giá gốc (trước KM): </span>
                                            }
                                            {
                                                originalPrice && <span className="font-italic font-weight-bold ml-1"><del> {formatPrice(originalPrice)}</del> đ</span>
                                            }
                                        </div>
                                    </div>
                                    {/* <div
                                            onClick={async () => {
                                                    await navigator.clipboard.writeText(firstImageUrl)
                                                    Toast.fire({
                                                        icon: 'success',
                                                        title: `Đã sao chép link ảnh`,
                                                        timer: 1000
                                                    })
                                            }}
                                        > */}
                                        <img 
                                        onClick={async () => {
                                                    await navigator.clipboard.writeText(firstImageUrl)
                                                    Toast.fire({
                                                        icon: 'success',
                                                        title: `Đã sao chép link ảnh`,
                                                        timer: 700
                                                    })
                                            }}
                                        src={firstImageUrl} width="70" className="ml-lg-5 order-1 order-lg-2" />
                                    {/* </div> */}
                                </div>
                            </li>
                        })
                    }}
                />
            </div>
        </div>
    </div>
})

export default SearchThuocsiProduct

interface ThuocsiProductModel {
    mId:            number;
    mCrawlDate:     string;
    mProductId:     number;
    mProductCode:   string;
    mSkuCode:       string;
    mProductName:   string;
    mImages:        string;
    mPurchasePrice: number;
    mRetailPrice:   number;
    mDealStatus:    boolean;
    mDealPrice:     number;
    mDealStart:     Date;
    mDealEnd:       Date;
    mUnit:          string;
    mVolumn:        string;
    mKeywords?:      string;
    mStockStatus?:      string;
    mUpdatedAt:     Date;
}
